// extracted by mini-css-extract-plugin
export default {"container":"style_container__T3F-2","wrapper":"style_wrapper__WLqxS","logoImage":"style_logoImage__pn4nC","authButton":"style_authButton__mYooW","btnEmpty":"style_btnEmpty__0QIZq"};